<template>
  <div class="wrapper-dropdown">
		<span @click="toggleDropdown()" v-html="selector">
			</span>
			<ul class="dropdown" v-show="active">
				<li v-for="(color,index) in colors"
				:key="index"
				@click="setColor(color.hex, color.name)">
					<span :style="{background: color.hex}">
				 	</span> {{color.name}}
				</li>
			</ul>
			<input type="hidden" v-model="selectedColor"></div>
</template>

<script>
export default {
	name: "ColorPicker",
	props: ['color-options', 'label', 'empty-option','defaultValue'],
  data() {
    return {
			// selected: this.defaultValue,
			active: false,
			selectedColor: this.defaultValue,
			selectedColorName: this.defaultValue,
			colors: this.colorOptions,
			noSelection: true
    };
  },
  computed: {
		selector: function() {
			if(!this.selectedColor && !this.emptyOption) {
				return this.label;
			}
			else if(!this.selectedColor && this.emptyOption) {
				if(this.emptyOption === "true") {
					return this.label;
				}
				else if(this.emptyOption !== "true" && this.noSelection === false) {
					return '<span class="noColor"></span> ' + this.emptyOption;
				}
				else {
					return this.label;
				}
			}
			else {
				return '<span style="background: ' + this.selectedColor + '"></span> ' + this.selectedColorName;
			}
		}
	},
  created() {
		this.selectedColor = this.defaultValue;
		this.selectedColorName = this.defaultValue;
  },
  methods: {
		setColor: function(color, colorName) {
			this.selectedColor = color;
			this.selectedColorName = colorName;
			this.active = false;
			this.noSelection = false;
			this.$emit('input', this.selectedColor);
		},
		toggleDropdown: function() {
			this.active = !this.active;
		},
  },
  watch: {
    defaultValue(newValue, oldValue) {
      this.selected = newValue;
      this.selectedColorName = newValue;
    }
  }
};
</script>

<style lang="scss">
* {
	box-sizing: border-box;
	font-family: "Arial";
}
.wrapper-dropdown {
    position: relative;
    width: 100%;
    background: #FFF;
    color: #2e2e2e;
    outline: none;
    cursor: pointer;
		border-radius: 4px;
		border: 1px solid rgba(33, 33, 33, 0.12);
}
.wrapper-dropdown > span {
	width: 100%;
	display: block;
	padding: 5px;
}
.wrapper-dropdown > span > span {
  padding: 0 12px;
  margin-right: 5px;
}
.wrapper-dropdown > span > span.noColor {
	background: #CCC;
	position: relative;
}
.wrapper-dropdown > span > span.noColor:after {
	content: "";
	background: red;
	-webkit-transform: rotate(-32deg);
  transform: rotate(-32deg);
  display: inline-block;
  width: 28px;
  height: 2px;
  position: absolute;
  bottom: 7px;
  left: -2px;
}
.wrapper-dropdown > span:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    right: 16px;
    top: calc(50% + 4px);
    margin-top: -6px;
	  border-width: 6px 3px 0 3px;
    border-style: solid;
	  border-color: #2e2e2e transparent;
}

.wrapper-dropdown .dropdown {
    position: absolute;
	  z-index: 10;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    font-weight: normal;
	  list-style-type: none;
	  padding-left: 0;
	  margin: 0;
	  border: 1px solid #ababab;
	  border-top: 0;
}

.wrapper-dropdown .dropdown li {
    display: block;
    text-decoration: none;
    color: #2e2e2e;
	  padding: 5px;
	  cursor: pointer;
	  min-height: 28px;
}

.wrapper-dropdown .dropdown li > span {
  padding: 0 12px;
  margin-right: 5px;
}
.wrapper-dropdown .dropdown li > span.noColor {
	background: #CCC;
	position: relative;
}
.wrapper-dropdown .dropdown li > span.noColor:after {
	content: "";
	background: red;
	-webkit-transform: rotate(-32deg);
  transform: rotate(-32deg);
  display: inline-block;
  width: 28px;
  height: 2px;
  position: absolute;
  bottom: 7px;
  left: -2px;
}

.wrapper-dropdown .dropdown li:hover {
    background: #eee;
	  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/ColorPicker.vue